import { StatusResponseType } from '../../state/status/status.types';

export const shouldShowAnimation = (
  currentStatus?: StatusResponseType,
  prevStatus?: StatusResponseType,
) => {
  if (!currentStatus || !prevStatus) {
    return false;
  }

  const { claimedBoxesCount: currentClaimedBoxesCount = 0 } = currentStatus;
  const { claimedBoxesCount: previousClaimedBoxesCount = 0 } = prevStatus;

  return (
    currentClaimedBoxesCount > previousClaimedBoxesCount ||
    (currentStatus.playerStatus !== prevStatus.playerStatus &&
      currentStatus.playerStatusState === 'ToBePromoted')
  );
};
